import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Stars } from "@/components/delivery/RatingBox";
import { fmtDateTime, fmtDate, waLink } from "@/lib/api";
import { cn } from "@/lib/utils";
import { ReplyBox } from "./ReplyBox";

const FILTERS = [["all", "Todas"], ["5", "5"], ["4", "4"], ["3", "3"], ["2", "2"], ["1", "1"], ["comment", "Com comentário"], ["pending", "Sem resposta"]];

const couponMsg = (r, store, slug) => `Olá, ${r.customer.split(" ")[0]}! Obrigado pela avaliação na ${store}. Seu cupom ${r.coupon.code} (${r.coupon.label}) vale até ${fmtDate(r.coupon.expires_at)}. Use no próximo pedido: ${window.location.origin}/cardapio/${slug}?cupom=${r.coupon.code}`;

export function RatingList({ items, store, slug, canReply, onReplied }) {
  const [f, setF] = useState("all");
  const list = items.filter((r) => f === "all" || (f === "comment" ? !!r.comment : f === "pending" ? !r.reply : r.stars === Number(f)));
  return (
    <div className="card-surface p-5 space-y-3" data-testid="rating-list">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="eyebrow">Últimas avaliações</p>
        <div className="flex flex-wrap gap-1">{FILTERS.map(([k, l]) => (
          <button key={k} onClick={() => setF(k)} className={cn("rounded-full border px-3 py-1 text-xs transition-colors", f === k ? "border-primary bg-primary/15 text-primary" : "hover:bg-muted")} data-testid={`rating-filter-${k}`}>{l}</button>
        ))}</div>
      </div>
      <ul className="divide-y">
        {list.map((r) => (
          <li key={r.order_id} className="py-3 space-y-1" data-testid={`rating-item-${r.number}`}>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <Stars value={r.stars} size="h-3.5 w-3.5" />
              <span className="font-medium">{r.customer}</span>
              <span className="text-xs text-muted-foreground">Pedido #{r.number} · {fmtDateTime(r.at)}{r.courier ? ` · ${r.courier}` : ""}</span>
            </div>
            {r.comment && <p className="text-sm italic text-muted-foreground">"{r.comment}"</p>}
            {r.coupon && (
              <p className="flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded bg-emerald-500/15 px-2 py-0.5 font-mono text-emerald-600 dark:text-emerald-400">{r.coupon.code} · {r.coupon.label}{r.coupon.used ? " · usado" : ""}</span>
                {!r.coupon.used && r.phone && <a href={waLink(r.phone, couponMsg(r, store, slug))} target="_blank" rel="noreferrer" className="flex items-center gap-1 font-medium text-emerald-600" data-testid={`rating-send-coupon-${r.number}`}><MessageCircle className="h-3.5 w-3.5" />Enviar cupom no WhatsApp</a>}
              </p>
            )}
            <ReplyBox r={r} canReply={canReply} store={store} slug={slug} onSaved={onReplied} />
          </li>
        ))}
        {!list.length && <li className="py-8 text-center text-sm text-muted-foreground" data-testid="rating-list-empty">Nenhuma avaliação neste filtro.</li>}
      </ul>
    </div>
  );
}
